import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Header, Paper, Title } from '../../components';
import CouponForm from './coupons.form';

import { config } from '../../api/config';
import { actions } from '../../state';

const CouponAdd = ({ dispatch, coupons: { loading }, history }) => {
  const onSubmitCoupon = payload => {
    dispatch(actions.coupons.createCouponAction(payload, history));
  };

  return (
    <section>
      <Header size="sm">
        <Title>{config.PAGES.addCoupon}</Title>
      </Header>
      <Paper size="sm">
        <CouponForm onSubmitCoupon={onSubmitCoupon} />
      </Paper>
    </section>
  );
};

const mapStateToProps = state => ({
  coupons: state.coupons,
});

CouponAdd.propTypes = {
  dispatch: PropTypes.func.isRequired,
  coupons: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(CouponAdd);
